import React, { useEffect, useRef, useState } from 'react';
import { Image } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import moment from 'moment';

import './YearMonthPicker.scss';

import deleteSelectedButton from '../../assets/images/drop_down_delete_selected.png';
import NarrowUp from '../../assets/images/drop_down_not_show_narrow.svg';

const YearMonthPicker = ({
  defaultValue = null,
  setValue = () => {},
  hideDeleteButton = false,
  placeholder = '',
}) => {
  const [selectedDate, setSelectedDate] = useState(defaultValue || new Date());
  const [isOpen, setIsOpen] = useState(false);
  const pickerRef = useRef(null);

  const handleDateChange = (date) => {
    setSelectedDate(new Date(date.getFullYear(), date.getMonth(), 1));
  };

  const formatDate = (date) => {
    return moment(date).format('MMM, yyyy');
  };

  const handleConfirm = () => {
    setValue(selectedDate);
    setIsOpen(false);
  };

  const handleCancel = () => {
    setValue(defaultValue);
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="year-month-picker" ref={pickerRef}>
      <div className="custom-input" onClick={() => setIsOpen(!isOpen)}>
        <label
          className={`btn-link-text-label ${
            defaultValue ? 'btn-link-text-label-active' : ''
          }`}
        >
          {defaultValue ? formatDate(defaultValue) : placeholder}
        </label>
        {hideDeleteButton ? null : (
          <Image
            src={deleteSelectedButton}
            className="filterable-dropdown-delete-selected"
            onClick={(e) => {
              e.stopPropagation();
              setValue();
            }}
          />
        )}
        <Image
          src={NarrowUp}
          className={`filterable-toogle-area-indicator ${
            isOpen ? 'rtoate180' : ''
          }`}
        />
      </div>

      {isOpen && (
        <div className="datepicker-popup">
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="yyyy/MM"
            showMonthYearPicker
            showFullMonthYearPicker
            inline
            shouldCloseOnSelect={false}
          />
          <div className="button-container">
            <button className="btn-back-button-common base-buttons-item base-buttons-secondary btn btn-primary cancel-btn" onClick={handleCancel}>
              Cancel
            </button>
            <button className="btn-further base-buttons-item base-buttons-main btn btn-primary confirm-btn" onClick={handleConfirm}>
              Confirm
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default YearMonthPicker;
